export function getDisabledDeleteMessage({
  folderIsShared,
  folderHasChildren,
  folderHasAssets,
  isFolderOwner,
  ownerName,
  folderIsVirtual,
}: {
  folderIsShared: boolean;
  folderHasChildren: boolean;
  folderHasAssets: boolean;
  isFolderOwner: boolean;
  ownerName?: string;
  folderIsVirtual: boolean;
}) {
  // Do not allow deleting virtual folders
  if (folderIsVirtual) {
    return "This folder cannot be deleted.";
  }
  // Disable "delete folder" ability if user is not the owner of the folder or the folder has subfolders
  if (folderHasChildren) {
    return "This folder can't be deleted because it has subfolders. Please move the subfolders and try again.";
  }
  if (folderHasAssets) {
    return "This folder can't be deleted because it has assets. Please move the assets and try again.";
  }
  // Disable ability to delete folder if
  // 1. user is not folder owner and not the account owner, super admin or an admin
  // OR
  // 2. user is not the folder owner and the folder is not shared (regardless of role)
  if (!folderIsShared && !isFolderOwner) {
    return `This folder can't be deleted because it is a personal folder and you are not the owner. Contact ${
      ownerName || "folder owner"
    } to delete the folder.`;
  }

  return "";
}

interface GetDisabledShareMessageInput {
  hasTeams: boolean;
  isVirtualFolder: boolean;
  rootFolderName?: string;
}

export function getDisabledShareMessage({
  hasTeams,
  isVirtualFolder,
  rootFolderName,
}: GetDisabledShareMessageInput) {
  if (!hasTeams) {
    return "This feature is not available for personal accounts.";
  }

  if (isVirtualFolder) {
    return "This folder can't be shared.";
  }

  // Disable "share folder" ability if folder is a subfolder/has a root folder
  if (rootFolderName) {
    return `This folder can't be shared because it is a subfolder. To change who it's shared with, edit ${
      rootFolderName || "the root folder"
    }'s sharing settings.`;
  }

  return "";
}

export function getDisabledMoveMessage({
  isBlockedByDepth,
  maxDepth = 5,
}: {
  isBlockedByDepth: boolean;
  maxDepth?: number;
}) {
  if (!isBlockedByDepth) {
    return "";
  }
  return `This folder can't be moved because it's already at the top level and at the ${maxDepth}-level subfolder limit.`;
}
